import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import EmailVerification from './EmailVerification';

import backgroundImage from '../../assets/images/login.png';
import logo from '../../assets/images/AMPLIFiCAM_logo_symbol.png';
import '../../vendor/styles/pages/authentication.scss';
import ChangePassword from './ChangePassword';

import style from '../Login/style.module.scss';

const PasswordReset = () => {
  const { token } = useParams();

  return (
    <div className={style.loginContainer} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <img className={style.logo} src={logo} alt="background-arena" />
      <Card className={style.formContainer}>
        <div>
          {token ? <ChangePassword token={token} /> : <EmailVerification /> }
        </div>
      </Card>
    </div>
  );
};

export default PasswordReset;
